import { ENUM__field_kind } from '@shared/dto/generation/graph_invoke/_enums/ENUM__field_kind';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { assert_equal, assert_false, assert_string_object_id_not_empty } from './utils_asserts';

export function assert_field_consumer(field: FIELD__base, generation_id_consumer: string) {
  assert_string_object_id_not_empty(generation_id_consumer);
  assert_equal(field.meta.graph_id, generation_id_consumer);

  assert_false(field.meta.ui__is_readonly);
  assert_false(field.meta.kind__is_output);
  assert_false(field.meta.data__is_linked);

  assert_equal(field.meta.field_kind, ENUM__field_kind.INPUT);
}
